import { IonPage, IonContent, IonToast, IonNote, IonInput, IonLabel, IonButton, IonIcon, IonSpinner } from "@ionic/react"
import React, { useContext, useState, useEffect } from "react"
import { Browser } from '@capacitor/browser';
import './Login.css'
import axios from 'axios';

import { getLoginInfo } from '../actions/loginInfo';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { selectLoginFail, selectLoginErrorMessage, unsetLoginFail } from "../features/login/loginSlice"
import { ServerUrlContext } from '../contexts/ServerUrlContext';
import Toolbar from "../components/Toolbar";
import { useTranslation } from "react-i18next";
import { useAzureAuth } from '../adf';
import { getConfig } from '../helpers/configHelper';

import { eyeOutline, eyeOffOutline, logoMicrosoft } from 'ionicons/icons';

const Login: React.FC = ()=>{
    const [t] = useTranslation("global");
    const [showPassword, setShowPassword] = useState(false);
    const [useAdfAuth, setUseAdfAuth] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { login: adfLogin, isAuthenticated } = useAzureAuth();

    document.title = `${t('Login')} | ${t('Portal de Prevención')}`

    const dispatch = useAppDispatch(); 
    const loginFail = useAppSelector(selectLoginFail);
    const loginErrorMessage = useAppSelector(selectLoginErrorMessage);
    const serverUrl = useContext(ServerUrlContext);
    
    // Determinar si usar autenticación ADF basado en configuración
    useEffect(() => {
        const loadConfig = async () => {
            try {
                const config = await getConfig();
                const adfEnabled = config.USE_ADF_AUTH === true;
                setUseAdfAuth(adfEnabled);
            } catch (error) {
                console.error('Error cargando configuración:', error);
                setUseAdfAuth(false);
            }
        };
        loadConfig();
    }, []);
    
    // Manejar estado de autenticación de ADF
    useEffect(() => {
        if (isAuthenticated) {
            setIsLoading(false);
        }
    }, [isAuthenticated]);

    const openResetPasswordSite = async () => {
        await Browser.open({ url: `/password_reset_custom/`});
    };
    
    // Función para iniciar sesión con ADF
    const handleAdfLogin = () => {
        setIsLoading(true);
        try {
            adfLogin();
        } catch (err) {
            console.error("Error al iniciar sesión con ADF:", err);
            setIsLoading(false);
        }
    };
      
    function login(e: React.SyntheticEvent) {
        e.preventDefault();
        const form = e.target as HTMLFormElement;
        const formData = new FormData(form);
        const username = formData.get('username') as string;
        const password = formData.get('password') as string;

        const target = {
            username,
            password,
            serverUrl
        };

        dispatch(getLoginInfo(target))
    }
    
    const onKeyPressed = ( e : any, n : any)=>{
        // ME ESTABA PETANDO PORQUE DICE QUE NO HABÍA LABEL
        // const input : HTMLInputElement = e.target
        // const labels: HTMLLabelElement = e.target.nextElementSibling
        // input.value ? labels.classList.add('active') : labels.classList.remove('active')
    }

    // const companySelector = (e:any) => {
    //     localStorage.setItem('server_url', e.target.value)
    // }

    return (
        <IonPage>
            <Toolbar/>
            <IonContent className="login-content" fullscreen>
                <div className="login">
                    <div className="login__head">
                        <div className="login__title">
                            {t('Portal de Prevención')}
                        </div>
                    </div>
                    <div className="login__wrap">
                        {/* Mostrar solo login con ADF cuando está activado */}
                        {useAdfAuth ? (
                            <div className="login__form">
                                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                                    <button 
                                        onClick={handleAdfLogin} 
                                        disabled={isLoading} 
                                        className="button-base solid microsoft-login-button" 
                                        title={t('Iniciar sesión con Microsoft')} 
                                        type="button">
                                            {isLoading ? (
                                                <IonSpinner color='white' className="microsoft-login-loader" name="lines" />
                                            ) : (
                                                <>
                                                    <IonIcon icon={logoMicrosoft} slot="start" />
                                                    {t('Iniciar sesión con Microsoft')}
                                                </>
                                            )}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            /* Formulario de login tradicional cuando ADF no está activado */
                            <>
                                <form action="" className="login__form modal-form" onSubmit={(e) => login(e)}>
                                    <ul className="modal-form__ul">
                                        <li>
                                            <IonLabel position="stacked">{t('Usuario')}</IonLabel>
                                            <IonInput onKeyUp={(event)=>{onKeyPressed(event, 0)}} name="username" id="username" required></IonInput>
                                        </li>
                                        <li className='pass-with-eye'>
                                            <IonLabel position="stacked">{t('Contraseña')}</IonLabel>
                                            <IonInput onKeyUp={(event)=>{onKeyPressed(event, 1)}} type={showPassword ? 'text' : 'password'} name="password" id="password" required></IonInput>
                                            <IonButton className='pass-with-eye__button' 
                                                       fill="clear"
                                                       size="small"
                                                       onClick={() => setShowPassword(!showPassword)}>
                                                <IonIcon icon={showPassword ? eyeOffOutline : eyeOutline} />
                                            </IonButton>
                                        </li>
                                    </ul>
                                    <button className="button-base solid modal-form__submit" title={t('Entrar')} type="submit">{t('Entrar')}</button>
                                </form>
                                
                                <IonNote><button title={t('He olvidado mi contraseña')} onClick={() => openResetPasswordSite()}>{t('He olvidado mi contraseña')}</button></IonNote>
                            </>
                        )}
                    </div>
                </div>

            </IonContent>
            <IonToast
                isOpen={loginFail}
                onDidDismiss={() => dispatch(unsetLoginFail())}
                message={loginErrorMessage || t('Usuario o contraseña incorrectos. Vuelva a intentarlo de nuevo, por favor')}
                duration={50000}
                cssClass= 'custom-toast'
                position={ window.innerWidth > 900 ? 'middle' : 'bottom'}
            />
        </IonPage>
    )
}

export default Login